export default {
    path: "/conectores",
    name: "Connectors",
    redirect: { path: "/conectores/detalhes" },
    meta: { requiresAuth: true },
    detail: {
        path: "detalhes/:id",
        name: "ConnectorDetail",
        component: () =>
            import(
                "@/presentation/views/Connectors/ConnectorDetail/ConnectorDetail.vue"
            ),
        redirect: { name: "ConnectorDetailInfo" },
        info: {
            path: "info",
            name: "ConnectorDetailInfo",
            component: () =>
                import(
                    "@/presentation/views/Connectors/ConnectorDetail/ConnectorDetailInfo/ConnectorDetailInfo.vue"
                ),
        },
    },
} as const